<template>
	<div>
		<div class="specimen" :class="isColumn ? 'flex-column' : ''">
			<div class="img-container">
				<img
					v-if="!not_image && is_specimen"
					onerror="this.src='/rooster/rooster.jpg'"
					@click.self="clickImageSpecimen(specimen)"
					class="img-specimen"
					:src="specimen.thumb ? specimen.thumb : '/rooster/rooster.jpg'"
					:alt="specimen.plate"
				/>
				<div class="icon-overlay">
					<FeatherIcon
						icon="EyeIcon"
						class="eye-icon cursor-pointer"
						size="14"
						@click="showSpecificDetailsModal = true"
					/>
				</div>
			</div>
			<div class="info">
				<div class="d-flex align-items-center">
					<div class="container-text">
						<p
							v-if="specimen.plate"
							@click="is_specimen && linkSpecimen(specimen.id)"
							class="plate"
							:class="[is_specimen ? 'cursor-pointer' : '']"
							:style="{
								color: is_specimen ? 'white' : '#ffffff',
								background: is_specimen ? 'rgba(0, 0, 0, 0.7)' : '#2C3E50',
							}"
						>
							{{ specimen.plate ? specimen.plate : "" }}
						</p>
						<!--  -->
						<p v-if="specimen.alias" class="alias text-center">
							{{ specimen.alias ? specimen.alias : "" }}
						</p>

						<p v-if="show_status" class="status_text text-center">
							<span
								v-b-tooltip.hover.top="specimen.in_galpon === 1 ? 'Disponible' : 'No disponible'"
								:class="{
									'text-danger': specimen.in_galpon === 0,
									'text-success': specimen.in_galpon === 1,
								}"
							>
								{{ specimen.status }}
							</span>
						</p>

						<p v-if="!specimen.alias && assignableAlias" class="alias text-center">
							<span class="text-danger">SIN ALIAS</span>
						</p>
						<!--  -->
						<p v-if="show_name_cate" class="mb-0 font-weight-bold status text-warning mb-25">
							{{ specimen.category }}
						</p>
						<p
							v-if="specimen.additional_plate"
							class="plate plate-additional"
							:class="[is_specimen ? 'cursor-pointer mt-0 ' : '']"
						>
							{{ specimen.additional_plate ? specimen.additional_plate : "" }}
						</p>
					</div>
					<div v-if="specimen.ran" class="ml-1">
						<IconSpecimenRan :guilty="specimen.guilty ? true : false" />
					</div>
				</div>
			</div>
			<!-- <template v-if="is_icon">
				<img
					v-if="is_specimen"
					src="/pollos/icon-rooster-plate-component.svg"
					alt=""
					:style="{ height: '20px' }"
				/>
				<img v-else src="/pollos/icon-chick-plate-component.svg" alt="" :style="{ height: '20px' }" />
			</template> -->
		</div>

		<SpecimenSpecificDetailModal
			v-if="showSpecificDetailsModal"
			:generalInfo="specimen"
			@close="showSpecificDetailsModal = false"
		/>

		<!-- Modal interno para casos donde el padre no intercepta el evento -->
		<SlidersImageVideo
			v-if="showImageModal && !interceptedByParent"
			:url="imageModalData.url"
			:type="imageModalData.type"
			:text="imageModalData.text"
			:text_url="imageModalData.text_url"
			:open="showImageModal"
			:idSpecimen="imageModalData.idSpecimen"
			@refreshSlider="closeImageModal"
		/>
	</div>
</template>

<script>
import IconSpecimenRan from "./IconSpecimenRan.vue"
import SpecimenSpecificDetailModal from "@/components/specimens/SpecimenSpecificDetailsModal.vue"
import SlidersImageVideo from "@/views/amg/header-bookmarks/SlidersImageVideo.vue"

export default {
	name: "SpecimenPlate",
	props: {
		isColumn: {
			type: Boolean,
			default: false,
		},
		specimen: {
			type: Object,
			required: true,
		},
		not_image: {
			type: Boolean,
			default: false,
		},
		setWidth: {
			type: String,
			default: "200px",
		},
		is_specimen: {
			type: Boolean,
			default: true,
		},
		is_icon: {
			type: Boolean,
			default: false,
		},
		show_name_cate: {
			type: Boolean,
			default: true,
		},
		assignableAlias: {
			type: Boolean,
			default: false,
		},
		show_status: {
			type: Boolean,
			default: false,
		},
		show_details_icon: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		IconSpecimenRan,
		SpecimenSpecificDetailModal,
		SlidersImageVideo,
	},
	data() {
		return {
			showImageModal: false,
			interceptedByParent: false,
			imageModalData: {
				url: null,
				type: "image",
				text: null,
				text_url: null,
				idSpecimen: null,
			},
		}
	},
	setup(props, context) {
		return {
			showSpecificDetailsModal: false,
			linkSpecimen: (id) => window.open(`/ejemplares/detalle/${id}`, "_blank"),
		}
	},
	mounted() {
		// Detectar si el padre está escuchando el evento image-clicked
		this.interceptedByParent = !!this.$listeners["image-clicked"]
	},
	methods: {
		clickImageSpecimen(item) {
			// Si el padre intercepta, emitir el evento
			if (this.interceptedByParent) {
				this.$emit("image-clicked", item)
			} else {
				// Si no, manejar localmente
				this.imageModalData = {
					url: item.image ? item.image : "/rooster/rooster.jpg",
					type: "image",
					text: `${item.plate} ${item.alias ? "-" : ""} ${item.alias ? item.alias : ""}`,
					text_url: `detalle/${item.id}`,
					idSpecimen: item.id,
				}
				this.showImageModal = true
			}
		},
		closeImageModal() {
			this.showImageModal = false
			this.imageModalData = {
				url: null,
				type: "image",
				text: null,
				text_url: null,
				idSpecimen: null,
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.specimen {
	display: flex;
	align-items: center;
	justify-content: space-between;
	column-gap: 1.5rem;
	// background: red;
	// width: auto;
}

@media screen and (min-width: 700px) {
	.specimen {
		flex-direction: row;
		justify-content: center;
	}
}
.img-container {
	position: relative;
	width: 50px;
	height: 50px;

	@media screen and (min-width: 700px) {
		width: 70px;
		height: 70px;
	}

	.icon-overlay {
		position: absolute;
		top: -5px;
		right: -10px;
		background-color: var(--primary) !important;
		border-radius: 50%;
		padding: 3px;
		z-index: 1;
		width: 22px;
		height: 22px;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

		.eye-icon {
			color: #fff !important;
			&:hover {
				transform: scale(1.2);
			}
		}
	}
}

.img-specimen {
	width: 100%;
	height: 100%;
	object-fit: cover;
	&:hover {
		background-color: rgba(0, 0, 0, 0.7);
	}
	cursor: pointer;
}
.info {
	display: flex;
	flex-direction: column;
	align-items: center;

	@media screen and (min-width: 700px) {
		align-items: center;
	}
	.alias {
		margin: 0.3rem 0;
		// font-weight: bold;
		color: #6e6b7b !important;
		font-size: 12.5px;
	}
	.status_text {
		margin: 0.3rem 0;
		font-weight: bold;
		font-size: 12px;
	}
	.container-text {
		display: flex;
		align-items: center;
		flex-direction: column;
	}
}
.plate {
	margin-top: 0.5rem;
	// background: rgba(0, 0, 0, 0.7);
	// color: white;
	font-weight: bold;
	padding: 0.08rem 0.5rem !important;
	border-radius: 6px;
	width: auto;
	font-size: 12px;
	margin-bottom: 0.5rem !important;
	@media screen and (min-width: 700px) {
		font-size: 14px;
		padding: 0.1rem 0.8rem !important;
		border-radius: 8px;
	}
}
.plate-additional {
	color: var(--primary);
}
</style>
